import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { StaffGuard } from './core/auth/staff.guard';
import { LoginComponent } from './core/auth/login/login.component';
import { LayoutComponent } from './core/layout/layout.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { CarListComponent } from './features/cars/car-list/car-list.component';
import { CarDetailComponent } from './features/cars/car-detail/car-detail.component';
import { BookingListComponent } from './features/bookings/booking-list/booking-list.component';
import { BookingCreateComponent } from './features/bookings/booking-create/booking-create.component';
import { BookingEditComponent } from './features/bookings/booking-edit/booking-edit.component';
import { BookingReportComponent } from './features/bookings/booking-report/booking-report.component';
import { BookingDetailComponent } from './features/bookings/booking-detail/booking-detail.component';
import { RentalListComponent } from './features/rentals/rental-list/rental-list.component';
import { RentalCreateComponent } from './features/rentals/rental-create/rental-create.component';
import { RentalDetailComponent } from './features/rentals/rental-detail/rental-detail.component';
import { RentalEditComponent } from './features/rentals/rental-edit/rental-edit.component';
import { RentalReturnComponent } from './features/rentals/rental-return/rental-return.component';
import { RentalReportComponent } from './features/rentals/rental-report/rental-report.component';
import { PaymentCreateComponent } from './features/payments/payment-create/payment-create.component';
import { ClientListComponent } from './features/clients/client-list/client-list.component';
import { ClientCreateComponent } from './features/clients/client-create/client-create.component';
import { ClientDetailComponent } from './features/clients/client-detail/client-detail.component';
import { ClientEditComponent } from './features/clients/client-edit/client-edit.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard, StaffGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'cars',
        component: CarListComponent,
      },
      {
        path: 'cars/:id',
        component: CarDetailComponent,
      },
      {
        path: 'bookings',
        component: BookingListComponent,
      },
      {
        path: 'bookings/new',
        component: BookingCreateComponent,
      },
      {
        path: 'bookings/:id/edit',
        component: BookingEditComponent,
      },
      {
        path: 'bookings/:id/report',
        component: BookingReportComponent,
      },
      {
        path: 'bookings/:id',
        component: BookingDetailComponent,
      },
      {
        path: 'rentals',
        component: RentalListComponent,
      },
      {
        path: 'rentals/new',
        component: RentalCreateComponent,
      },
      {
        path: 'rentals/:id',
        component: RentalDetailComponent,
      },
      {
        path: 'rentals/:id/edit',
        component: RentalEditComponent,
      },
      {
        path: 'rentals/:id/return',
        component: RentalReturnComponent,
      },
      {
        path: 'rentals/:id/report',
        component: RentalReportComponent,
      },
      {
        path: 'payments/new',
        component: PaymentCreateComponent,
      },
      {
        path: 'clients',
        component: ClientListComponent,
      },
      {
        path: 'clients/new',
        component: ClientCreateComponent,
      },
      {
        path: 'clients/:id',
        component: ClientDetailComponent,
      },
      {
        path: 'clients/:id/edit',
        component: ClientEditComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
